import adminEmployeesEmployeeNavTemplate from './nav/template.html';
import AdminEmployeesEmployeeNavCtrl from './nav';

import usersActivitiesTemplateGet from 'controllers/users/learning/activities/template.html';
import usersActivitiesCtrl from 'controllers/users/learning/activities/';

import usersProfileTemplate from 'controllers/users/account/profile/template.html';
import UsersProfileController from 'controllers/users/account/profile';

import usersCertificatesTemplate from 'controllers/users/certificates/get/template.html';
import UsersCertificatesController from 'controllers/users/certificates/get';

import usersCertificatesPutTemplate from 'controllers/users/certificates/put/template.html';
import UsersCertificatesPutController from 'controllers/users/certificates/put';

import usersCertificateEditTemplate from 'controllers/users/certificates/edit/template.html';
import UsersCertificateEditController from 'controllers/users/certificates/edit';

import adminEmployeesEmployeeCoursesTemplate from './courses/template.html';
import adminEmployeesEmployeeCoursesController from './courses';

import usersLicenseTemplate from 'controllers/users/account/licenses/get/template.html';
import usersLicenseController from 'controllers/users/account/licenses/get';
import usersCarryOverTemplate from 'controllers/users/account/licenses/license/carryOver/template.html';
import usersCarryOverController from 'controllers/users/account/licenses/license/carryOver';

import usersAttachmentsTemplateGet from 'controllers/users/attachments/get/template.html';
import usersAttachmentsCtrl from 'controllers/users/attachments/get';

import userLicensesLicenseNavTemplate from 'controllers/users/account/licenses/license/nav/template.html';
import userLicensesLicenseNavCtrl from 'controllers/users/account/licenses/license/nav';
import userLicensesLicenseEditTemplate from 'controllers/users/account/licenses/license/edit/template.html';
import userLicensesLicenseEditCtrl from 'controllers/users/account/licenses/license/edit';
import userLicensesLicenseAttachmentsTemplate from 'controllers/users/account/licenses/license/attachments/template.html';
import userLicensesLicenseAttachmentsCtrl from 'controllers/users/account/licenses/license/attachments';
import userLicensesLicenseExtensionsTemplate from 'controllers/users/account/licenses/license/extensions/template.html';
import userLicensesLicenseExtensionsCtrl from 'controllers/users/account/licenses/license/extensions';
import userSettingsNavTemplate from 'controllers/users/account/nav/template.html';
import userSettingsCtrl from 'controllers/users/account/nav';
import usersCertificationsTemplate from 'controllers/users/account/certifications/template.html';
import usersCertificationsCtrl from 'controllers/users/account/certifications';

const adminEmployeesEmployeeNavState = {
  url: '/:employeeID',
  abstract: true,
  views: {
    'a@app': {
      template: adminEmployeesEmployeeNavTemplate,
      controller: AdminEmployeesEmployeeNavCtrl,
      controllerAs: 'adminEmployeesEmployeeTabsCtrl'
    }
  }
};

const adminEmployeesEmployeeSettingsState = {
  url: '/settings',
  stateName: 'Settings',
  abstract: true,
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/licenses')
  },
  views: {
    a: {
      template: userSettingsNavTemplate,
      controller: userSettingsCtrl,
      controllerAs: 'NavCtrl'
    }
  }
};

const adminEmployeesEmployeeActivitiesState = {
  url: '/activities?tab',
  stateName: 'User Activities',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: usersActivitiesTemplateGet,
      controller: usersActivitiesCtrl,
      controllerAs: 'UsersLearningActivitiesCtrl'
    }
  }
};

const adminEmployeesEmployeeAttachmentsState = {
  url: '/attachments',
  stateName: 'User Attachments',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: usersAttachmentsTemplateGet,
      controller: usersAttachmentsCtrl,
      controllerAs: 'userAttachmentsCtrl'
    }
  }
};

const adminEmployeesEmployeeEventsState = {
  url: '/events?tab',
  stateName: 'Events',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: '<progress-events></progress-events>'
    }
  }
};

const adminEmployeesEmployeeTracksState = {
  url: '/tracks',
  stateName: 'Track Progress',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: '<progress-tracks></progress-tracks>'
    }
  }
};

const adminEmployeesEmployeeCoursesState = {
  url: '/courses?tab',
  stateName: 'Course Progress',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: adminEmployeesEmployeeCoursesTemplate,
      controller: adminEmployeesEmployeeCoursesController,
      controllerAs: 'AdminEmployeesEmployeeCoursesCtrl'
    }
  }
};

const adminEmployeesEmployeeComplianceState = {
  url: '/compliance',
  stateName: 'Employee Compliance Summary',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/admin/employees/:id/compliance')
  },
  views: {
    a: {
      template: `<compliance-tracker></compliance-tracker><compliance-overview></compliance-overview><detailed-compliance-breakdown></detailed-compliance-breakdown>`
    }
  }
};

const adminEmployeesEmployeeCertificatesState = {
  url: '/certificates',
  stateName: 'Employee Certificates',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: usersCertificatesTemplate,
      controller: UsersCertificatesController,
      controllerAs: 'userCertificatesGetCtrl'
    }
  }
};

const adminEmployeesEmployeeCertificatesHoursState = {
  url: '/hours',
  stateName: 'Add Hours',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.admin.employees.employee': {
      template: usersCertificatesPutTemplate,
      controller: UsersCertificatesPutController,
      controllerAs: 'userCertificatePutCtrl'
    }
  }
};

const adminEmployeesEmployeeCertificatesEditState = {
  url: '/:certId/edit',
  stateName: 'Edit Certificate',
  data: { specialClass: 'fixed-sidebar' },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/admin/employees/:id/:certId/edit')
  },
  views: {
    'a@app.admin.employees.employee': {
      template: usersCertificateEditTemplate,
      controller: UsersCertificateEditController,
      controllerAs: 'userCertificateEditCtrl'
    }
  }
};

const adminEmployeesEmployeeProfileState = {
  url: '/profile',
  stateName: 'Employee Profile',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: usersProfileTemplate,
      controller: UsersProfileController,
      controllerAs: 'userProfileCtrl'
    }
  }
};

const adminEmployeesEmployeeLicenseState = {
  url: '/licenses?source',
  stateName: 'Employee Licenses',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: usersLicenseTemplate,
      controller: usersLicenseController,
      controllerAs: 'usersLicenseCtrl'
    }
  }
};

const adminEmployeesEmployeeLicensesLicenseNavState = {
  url: '/:reg_id',
  stateName: 'License',
  abstract: true,
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/licenses'),
    loadRegulators: /* @ngInject */ RegulatorClass => RegulatorClass.loadRegulators()
  },
  views: {
    'nav-a@app.admin.employees.employee.settings': {
      template: userLicensesLicenseNavTemplate,
      controller: userLicensesLicenseNavCtrl,
      controllerAs: 'NavCtrl'
    }
  }
};

const adminEmployeesEmployeeLicensesLicenseEditState = {
  url: '/edit',
  stateName: 'License Edit',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.admin.employees.employee.settings': {
      template: userLicensesLicenseEditTemplate,
      controller: userLicensesLicenseEditCtrl,
      controllerAs: 'LicenseEditCtrl'
    }
  }
};

const adminEmployeesEmployeeLicensesLicenseAttachmentsState = {
  url: '/attachments',
  stateName: 'License Attachments',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.admin.employees.employee.settings': {
      template: userLicensesLicenseAttachmentsTemplate,
      controller: userLicensesLicenseAttachmentsCtrl,
      controllerAs: 'LicenseAttachmentsCtrl'
    }
  }
};

const adminEmployeesEmployeeCarryOverHours = {
  url: '/carryover',
  stateName: 'Carry Over Hours',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.admin.employees.employee.settings': {
      template: usersCarryOverTemplate,
      controller: usersCarryOverController,
      controllerAs: 'LicenseCarryOverCtrl'
    }
  }
};

const adminEmployeesEmployeeLicensesLicenseExtensionsState = {
  url: '/extensions',
  stateName: 'License Extensions',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.admin.employees.employee.settings': {
      template: userLicensesLicenseExtensionsTemplate,
      controller: userLicensesLicenseExtensionsCtrl,
      controllerAs: 'LicenseExtensionsCtrl'
    }
  }
};

const adminEmployeesEmployeeCertificationsState = {
  url: '/certifications',
  stateName: 'Certifications',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: usersCertificationsTemplate,
      controller: usersCertificationsCtrl,
      controllerAs: 'UserCertificationsCtrl'
    }
  }
};

export {
  adminEmployeesEmployeeNavState,
  adminEmployeesEmployeeActivitiesState,
  adminEmployeesEmployeeAttachmentsState,
  adminEmployeesEmployeeCarryOverHours,
  adminEmployeesEmployeeCertificatesState,
  adminEmployeesEmployeeCertificatesEditState,
  adminEmployeesEmployeeCertificatesHoursState,
  adminEmployeesEmployeeComplianceState,
  adminEmployeesEmployeeCoursesState,
  adminEmployeesEmployeeEventsState,
  adminEmployeesEmployeeProfileState,
  adminEmployeesEmployeeTracksState,
  adminEmployeesEmployeeLicenseState,
  adminEmployeesEmployeeLicensesLicenseNavState,
  adminEmployeesEmployeeLicensesLicenseEditState,
  adminEmployeesEmployeeLicensesLicenseAttachmentsState,
  adminEmployeesEmployeeLicensesLicenseExtensionsState,
  adminEmployeesEmployeeSettingsState,
  adminEmployeesEmployeeCertificationsState
};



// WEBPACK FOOTER //
// ./src/app/controllers/admin/employee/index.js